<template>
  <div class="app-container">
    <el-table
      :ref="masterList.tableKey"
      :data="masterList.tableData"
      border
      fit
      stripe
      highlight-current-row
      row-key="id"
      :header-cell-style="{ background: '#57a2f9', color: '#FFF' }"
      default-expand-all
      :tree-props="{ children: 'childrenSubjectList', hasChildren: 'hasChildren' }"
    >
      <!-- lazy -->
      <!-- :load="loadChildrenSubjectList" -->
      <!-- :expand-row-keys="expandRowKeys" -->
      <el-table-column
        v-for="(column, index) in masterList.tableColumns"
        :key="index"
        resizable
        :width="column.width ? column.width : 'auto'"
        show-overflow-tooltip
        :label="column.title"
        :prop="column.prop"
        header-align="center"
        :align="column.align || 'left'"
      >
        <template slot-scope="scope">
          <span v-if="column.prop === 'levelStr' && scope.row['level'] === 0">一级/二级</span>
          <span v-else>{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        header-align="center"
        width="170"
      >
        <template slot-scope="scope">
          <el-link
            v-if="checkPermission(['expense_subject_add']) && scope.row.level < 2"
            type="success"
            icon="icon iconfont icon-add"
            @click="addFun(scope.row)"
          >
            新增
          </el-link>
          <el-link
            v-if="checkPermission(['expense_subject_edit']) && scope.row.level > 0"
            type="primary"
            icon="icon iconfont icon-edit"
            style="padding-left: 8px;"
            @click="editFun(scope.row)"
          >
            修改
          </el-link>
          <el-link
            v-if="checkPermission(['expense_subject_del']) && !scope.row.childrenSubjectList && scope.row.level > 0"
            type="danger"
            icon="icon iconfont icon-remove"
            style="padding-left: 8px;"
            @click="delFun(scope.row)"
          >
            作废
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
import checkPermission from '@/utils/permission'
// 数据请求
import { getExpenseSubjectTreeApi, saveOrUpdateExpenseSubjectApi } from '@/api/expenseSubject'
export default {
  name: 'ExpenseSubject',
  components: {
    AddEditViewDialog
  },
  mixins: [],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [
          { title: '科目名称', prop: 'name' },
          { title: '级别', prop: 'levelStr', width: 80, align: 'center' },
          { title: '备注', prop: 'remark' }
        ], // Table列
        tableKey: 'expense_subject_master', // Table Key
        tableData: [], // Table数据
        tableQuery: {
        }
      },
      id: null, // 选中的单据ID
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created () {
    this.requestMasterListData()
  },
  methods: {
    checkPermission,
    loadTableData(){
      this.requestMasterListData()
    },
    // 请求主数据列表
    requestMasterListData () {
      let _this = this
      _this.masterList.tableData = []
      getExpenseSubjectTreeApi({isTable: 1}).then((response) => {
        const { data } = response
        _this.masterList.tableData = data
      }).catch(() => { })
    },
    // 延迟加载下属区域列表
    loadChildrenSubjectList (tree, treeNode, resolve) {
      getExpenseSubjectTreeApi({ id: tree.id }).then((response) => {
        const { data } = response;
        resolve(data);
      }).catch(() => { });
    },
    //新增
    addFun (args) {
      this.eventType = 'add'
      this.id = args.id
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增费用科目'
    },
    // 修改
    editFun (args) {
      if (!args) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args.id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改费用科目'
    },
    // 作废
    delFun (args) {
      if (!args) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定作废该费用科目？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateExpenseSubjectApi({ id: args.id, isDel: 1 }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    }
  }
}
</script>
